import { procurementAPI } from "../../axios";

export const actions = {

    //PostingFileLabel
    GetAllPFL(){
        return procurementAPI.get(`PostingFileLabel/All`);
    },
    GetSinglePFL(context, data){
        return procurementAPI.get(`PostingFileLabel/${data}`);
    },
    UpdatePFL(context, data){
        return procurementAPI.put(`PostingFileLabel/${data.id}`, data);
    },
    DeletePFL(context, data){
        return procurementAPI.delete(`PostingFileLabel/${data}`);
    },
    CreatePFL(context, data){
        return procurementAPI.post(`PostingFileLabel/`, data);
    },
}